import { Component, OnInit, Input } from '@angular/core';
import { Container } from './models/container';
import { Carrier } from './models/carrier';
import { ContainerUtility } from '../utils/container-utility';
import { Aliquot } from './models/aliquot';
import { ReactionSet } from './models/reaction-set';


@Component({
  selector: 'app-container-view',
  templateUrl: './container-view.component.html',
  styleUrls: ['./container-view.component.css']
})
export class ContainerViewComponent implements OnInit {
  constructor() { }

  @Input() selectedContainer: Container;
  @Input() hasToggle: boolean;
  @Input() isCarrier: boolean;
  @Input() showChemical: boolean;
  @Input() showPrimer: boolean;

  headerColumns: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  headerRows: string[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  isVertical = false;
  containerUtil: ContainerUtility = new ContainerUtility();
  reactionPlateQuadrantBarcode: string = null;
  reactionPlateQuadrantState: string = null;
  ngOnInit() {
  }

  ngOnChanges() {
    if (!this.isCarrier) {
      this.reactionPlateQuadrantBarcode = this.getQuadrantBarcodeForReactionplate();
    }
  }
  //Only for carrier, not for reaction Plate
  private getStateAsString(selectedContainer: Container): string {
    return this.containerUtil.getStateAsString(selectedContainer);
  }

  //Only for carriers, not for reactionPlate
  private getCarrierTypeAsString(selectedContainer: Container): string {
    return this.containerUtil.getCarrierTypeAsString(selectedContainer);
  }

  getQuadrantBarcodeForReactionplate(): string {

    this.reactionPlateQuadrantState = "";
    let selectedCarrierQuadrant = this.selectedContainer;
    for (var i = 0; i < selectedCarrierQuadrant.containerItems.length; i++) {
      let containerItem = selectedCarrierQuadrant.containerItems[i];
      if (containerItem != null && containerItem.containerItemAware != null) {
        let reactionSet = containerItem.containerItemAware as ReactionSet;
        for (var j = 0; j < reactionSet.reactionSetItems.length; j++) {
          let material = reactionSet.reactionSetItems[j] as Aliquot;
          if (material != null) {
            let carrier = new Carrier;
            carrier.state = material.sourceCarrierState;
            this.reactionPlateQuadrantState = this.getStateAsString(carrier);
            return material.sourcePlateBarcode;
          }
        }
      }

    }
    return "";
  }

}
